// extracted by mini-css-extract-plugin
module.exports = {"newMovies":"Nouveautes_newMovies__pPauC","plusDinfo":"Nouveautes_plusDinfo__19FGN","oeil":"Nouveautes_oeil__12VYm","favoriteSelected":"Nouveautes_favoriteSelected__21-Lv"};